<template>
  <v-app :dark="isDark" :class="{ 'dark-mode': isDark }">
    <v-container>
    <v-card :dark="isDark" :class="{ 'dark-mode': isDark }" rounded="lg" elevation="2" shaped class="pa-4">
      <v-card-title>24</v-card-title>
      <v-card-subtitle class="task-description">Дней можете взять</v-card-subtitle>
      <v-card-actions class="pa-2">
        <v-btn
            large
            color="#1751D0"
            class="ma-0"
            style="width: 100%; border-radius: 12px"
            @click="openRequestVacation"
        >
          Запросить отпуск
        </v-btn>
      </v-card-actions>
    </v-card>
      <div>
      <v-tabs class="vacationTabs" :dark="isDark" v-model="activeTab" fixed-tabs>
        <v-tab>
          Активные
        </v-tab>
        <v-tab>История</v-tab>
      </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <div v-if="requests">
              <div v-for="(request, i) in requests" :key="i" class="pa-4 requestItem">
                <div class="requestItemHeader">
                  <p style="color: var(--text-color)">{{getDateRangeText(request.dateRange)}}</p>
                  <p style="color: var(--text-color)" v-text="formatDate(request.createdAt)"></p>
                </div>
                <p style="color: var(--text-color)">Заявка обрабатывается</p>
              </div>
            </div>
            <div v-else class="pa-4 requestItem">
              <p style="color: var(--text-color); text-align: center">У вас пока нет активных заявок</p>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="pa-4 requestItem">
              <p style="color: var(--text-color); text-align: center">У вас пока истории заявок</p>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <h2 style="color: var(--text-color)">Как мы считаем отпускные</h2>
      <v-list class="pa-4 howCount" :dark="isDark" :class="{ 'dark-mode': isDark }">
        <v-list-item v-for="(item, i) in listItems" :key="i">
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
  </v-app>
</template>

<script>
import {
  isWebViewBridgeAvailable,
  setTitle,
  backArrow,
  storage
} from '@orta/bridge';

export default {
  data() {
    return {
      isVisibleRes: null,
      setModeRes: null,
      theme: 'light',
      activeTab: 0,
      requests: null,
      listItems: [
        {icon: 'mdi-calendar-multiselect', subtitle: 'Из 22 рабочих дней', title: '15 дней отработано'},
        {icon: 'mdi-poll', subtitle: 'Формула вычисления', title: '111 000 ₸  * 15 = 115 000 ₸'},
      ]
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },
    getDateRangeText(range) {
      console.log('Received range:', range, typeof range);
      if (!range || !Array.isArray(range) || range.length === 0) return 'неверный формат';

      if (range.length === 1) {
        return this.formatDate(range[0]);
      }

      if (range.length === 2) {
        const startDate = new Date(range[0]);
        const endDate = new Date(range[1]);
        if (isNaN(startDate) || isNaN(endDate)) {
          console.warn('Invalid date:', startDate, endDate);
          return 'невалидная дата';
        }

        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
        return `${this.formatDate(range[0])} - ${this.formatDate(range[1])} (${diffDays} дн.)`;
      }

      return 'неподдерживаемый формат';
    },
    async loadStoredRequests() {
      try {
        const getVacations = await storage.getItem('vacations');
        console.log(getVacations);
        this.requests = JSON.parse(getVacations);
      } catch (error) {
        console.error(error);
      }
    },
    openRequestVacation() {
      this.$router.push({ name: 'VacationRequest' });
    },
    goBack() {
      this.$router.replace({ name: 'HomeView', replace: true });
    },
  },
  mounted() {
    if (isWebViewBridgeAvailable()) {
      setTitle('Отпуск')
      backArrow.setVisible(true)
      backArrow.setMode(true)
      backArrow.setOnClickHandler(this.goBack.bind(this));
      this.loadStoredRequests();
    }
  },
  created() {
    this.theme = this.$route.query.theme || localStorage.getItem('theme') || 'light';
  },
  computed: {
    isDark() {
      return this.theme === 'dark';
    },
  }
}
</script>

<style>
.requestItem {
  background-color: var(--bg-color);
}

.requestItemHeader {
  display: flex;
  justify-content: space-between;
}

.vacationTabs {
  border-radius: 6px;
  overflow: hidden;
}

.howCount {
  border-radius: 16px !important;
}
</style>
